export default __webpack_public_path__ + "static/media/motorcycle3.dd815140.png";